<template>
  <div class="header_root">
    <phone-only class="header">
      <div class="hd">
        <router-link
          :to="{name: 'home'}"
          class="title"
        >
          一亩田商户端
        </router-link>
        <div
          class="nav_icon"
          @click.stop.prevent="toggleNavBarList"
        />
      </div>
    </phone-only>
    <pc-only class="header">
      <div class="hd mint-field">
        <div
          :to="{name: 'home'}"
          class="title"
          style="width:130px; display:flex"
        >
          <img
            src="http://img.yimutian.com/crm/66ea34de2d211f498906154700a6005c.png"
            alt=""
            @click="toHome"
          >
        </div>
        <div class="mint-cell-value">
          <!-- <div class="nav_icon" @click.stop.prevent="toggleNavBarList"></div> -->
          <!-- <div class="menu_search flex">
            <input class="menu_search_input flex1" placeholder="请输入搜索内容" v-model="searchTxt" />
            <div class="search_btn">搜索</div>
          </div> -->
          <div
            v-if="showNav"
            class="nav_title"
          >
            <div class="name">
              {{ navName }}
            </div>
          </div>
          <div class="user_info flex1">
            <div
              class="notice_icon"
              @click.stop="toChat"
            >
              <div
                v-if="notice_count && $router.currentRoute.name!=='chat'"
                class="notice_count"
              >
                {{ notice_count > 99 ? '99+' : notice_count }}
              </div>
              <img
                class="avatar_txt notice"
                src="http://img.yimutian.com/misc/5cc6948a6ef1434e6e56527198b9001d.png"
              >
            </div>
            <div
              v-show="infoDialog && $router.currentRoute.name!=='chat'"
              class="info_dialog"
            >
              <img
                class="icon"
                src="http://img.yimutian.com/misc/5cc6948a6ef1434e6e56527198b9001d.png"
                alt=""
              >
              <div
                class="info"
                @click.stop="toChat"
              >
                <p class="name">
                  {{ pullMsg.title }}
                </p>
                <p class="msg">
                  {{ pullMsg.content }}
                </p>
              </div>
              <img
                class="close"
                src="http://img.yimutian.com/misc/5cc6949c5c26555cbd16bfcc1169da71.png"
                alt=""
                @click="infoDialog=false"
              >
            </div>
            <img
              v-if="!portrait && !username"
              class="avatar"
              src="https://img.yimutian.com/misc/5996d9cf6ef1434b6a0075bbf9ce8e46-28-28.png"
              @mouseover="popupVisible=true"
            >
            <img
              v-if="portrait"
              :src="portrait | aspectFill(28, 28)"
              class="avatar"
              @mouseover="popupVisible=true"
            >
            <div
              v-if="!portrait && username"
              class="avatar_txt"
              @mouseover="popupVisible=true"
            >
              {{ username[0] }}
            </div>
            <mt-popup
              v-model="popupVisible"
              :modal="false"
              class="user_info_popup_ctn"
              position="top"
              popup-transition="popup-fade"
            >
              <div
                class="user_info_popup"
                style="z-index: 10"
              >
                <div class="name">
                  {{ username }}
                </div>
                <div
                  v-if="phone"
                  class="phone"
                >
                  {{ phone }}
                </div>
                <div
                  v-if="regDate"
                  class="date"
                >
                  注册日期
                </div>
                <div
                  class="logout"
                  @click="logout"
                >
                  退出登录
                </div>
              </div>
            </mt-popup>
            <div
              v-if="popupVisible"
              style="z-index: 9;width: 100%; height: 100%; position: fixed; top:0;left: 0; background-color: transparent"
              @click="popupVisible=false"
            />
          </div>
        </div>
      </div>
    </pc-only>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { MessageBox } from 'element-ui'
import { header } from '@/api.js'
import { helper } from '@ymt/gfw-axios'
import { constants } from 'crypto'

export default {
  data() {
    return {
      portrait: '',
      username: '',
      phone: '',
      regDate: '',
      popupVisible: false,
      infoDialog: false
    }
  },
  computed: mapState({
    showBarList: state => state.showBarList,
    showNav: state => state.showNav,
    navName: state => state.navName,
    pullMsg: state => state.chat.pullMsg,
    msgTimestamp: state => state.chat.msgTimestamp,
    notice_count: state => state.chat.notice_count,
    customer_id: state => state.chat.customer_id
  }),
  watch: {
    msgTimestamp() {
      this.infoDialog = true
    }
  },
  created() {
    header.getUserinfo().then(({ data: res }) => {
      if (res.status === 0) {
        this.portrait = res.data.portrait
        this.username = res.data.user_name
        this.phone = res.data.mobile
        this.regDate = res.data.regDate
        localStorage.setItem('portrait', this.portrait)
        localStorage.setItem('username', this.username)
      }
    })
  },
  methods: {
    toggleNavBarList() {
      if (this.showBarList) {
        this.$store.commit('hideNavBarList')
      } else {
        this.$store.commit('showNavBarList')
      }
    },
    hideNavBarList() {
      this.$store.commit('hideNavBarList')
    },
    // 退出
    logout() {
      this.popupVisible = false
      MessageBox.confirm('确定退出登录?', '', {
        showCancelButton: true
      })
        .then(action => {
          header.logout().then(({ data: res }) => {
            if (res.status === 0) {
              helper.clearSid()
              this.$store.state.chat.peer_uid = ''
              this.$store.state.chat.customer_id = ''
              this.$router.push({ name: 'login' })
            }
          })
        })
        .catch(() => {})
    },
    toChat() {
      this.infoDialog = false
      if (this.$router.currentRoute.name === 'chat') {
        return
      }
      // this.$router.push('chat')
      this.$store.commit('setchatDialog', true)
      if (this.pullMsg.dialog_id) {
        if (Number(this.pullMsg.to_id) === Number(this.pullMsg.from_id)) {
          let idArray = this.pullMsg.dialog_id.replace(/c_/g, '').split('-')
          idArray.forEach(element => {
            if (Number(element) !== Number(this.pullMsg.from_id)) {
              this.$store.state.chat.peer_uid = Number(element)
            }
          })
        } else {
          this.$store.state.chat.peer_uid = this.pullMsg.from_id
        }
        this.$store.state.chat.message_list = []
      }
    },
    toHome() {
      this.$store.commit('setNavStatus', 0)
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
<style lang="less">
.pc_only {
  .user_info {
    .v-modal {
      background: transparent;
    }
  }
}
</style>

<style lang="less" scoped>
@import '../assets/lib.less';
.header {
  background-color: #ffffff;
}
.title {
  text-decoration: none;
}
.phone_only {
  .header_root {
    width: 100%;
    height: 96 / @rem;
  }
  .header {
    height: 96 / @rem;
    .hd {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: space-between;
      padding: 0 24 / @rem;
      .title {
        color: #333;
        font-size: 36 / @rem;
      }
      .nav_icon {
        cursor: pointer;
        width: 36 / @rem;
        height: 100%;
        background: url('http://img.yimutian.com/crm/5ba3148e6ef1433be531f569e815afa0.png')
          no-repeat center center;
        background-size: 100%;
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      }
    }
  }
}
.pc_only {
  .header_root {
    width: 100%;
    height: 60px;
  }
  .header {
    height: 60px;
    .hd {
      display: flex;
      height: 100%;
      .title {
        color: #fff;
        font-size: 18px;
        text-align: center;
        height: 60px;
        line-height: 60px;
        background: #333333;
        transition: width 0.3s;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 83px;
          height: 46px;
        }
      }
      .nav_icon {
        cursor: pointer;
        width: 20px;
        height: 100%;
        background: url(http://img.yimutian.com/crm/5ba4972f64008157d9314c589a15c4f4.png)
          no-repeat center center;
        background-size: 100%;
        margin-left: 22px;
      }
      .nav_title{
        display:flex;
        justify-content: center;
        width:150px;
        border-right:1px solid #dedede;
          .name{
            text-align: center;
            font-size:16px;
            width: 110px;
            height: 59px;
            line-height:50px;
            border-bottom:1px solid #dedede;
          }
        }
      .user_info {
        text-align: right;
        .avatar {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-right: 46px;
          cursor: pointer;
          position: relative;
          z-index: 8;
        }
        .avatar_txt {
          display: inline-block;
          margin-right: 46px;
          width: 28px;
          height: 28px;
          line-height: 28px;
          border-radius: 50%;
          color: #fff;
          text-align: center;
          font-size: 14px;
          background-color: #d0d0d0;
          cursor: pointer;
          position: relative;
          z-index: 8;
          vertical-align: top;
        }
        .notice {
          background: #fafafa;
        }
        a {
          position: relative;
        }
        .notice_icon {
          display: inline;
          position: relative;
        }
        .notice_count {
          min-width: 0.16rem;
          height: 0.16rem;
          text-align: center;
          position: absolute;
          left: 15px;
          z-index: 9999;
          background: #f43530;
          color: #ffffff;
          border-radius: 0.12rem;
          font-size: 0.14rem;
          cursor: pointer;
        }
        .info_dialog {
          width: 3rem;
          height: 0.63rem;
          position: absolute;
          top: 0.6rem;
          right: 0.6rem;
          display: flex;
          background: #ffffff;
          align-items: center;
          box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.2);
          border-radius: 8px;
          z-index: 11;
          .icon {
            width: 0.32erm;
            height: 0.32rem;
            padding: 0.2rem;
          }
          .close {
            width: 0.18rem;
            height: 0.18rem;
            padding: 0 0.2rem;
          }
          .info {
            margin: 0;
            width: 2rem;
            text-align: left;
            display: flex;
            flex-direction: column;
            justify-items: center;
            color: #333333;
            font-size: 0.14rem;
            cursor: pointer;
            .msg {
              color: #999999;
              font-size: 0.12rem;
            }
          }
          p {
            margin: 0;
            padding: 0.03rem 0;
          }
          &:before {
            content: ' ';
            width: 0;
            height: 0;
            right: 0.65rem;
            top: -0.1rem;
            position: absolute;
            border-left: 0.1rem solid transparent;
            border-right: 0.1rem solid transparent;
            border-bottom: 0.1rem solid #ffffff;
            z-index: 999;
          }
        }
        .user_info_popup_ctn {
          position: fixed;
          top: 52px;
          right: 14px;
          left: auto;
          transform: none;
          box-shadow: 0 -4px 18px -0px rgba(0, 0, 0, 0.3);
          border-radius: 4px;
          min-width: 120px;
        }
        .user_info_popup {
          border-radius: 8px;
          padding: 16px;
          text-align: center;
        }
        .user_info_popup::before {
          display: inline-block;
          width: 0;
          height: 0;
          border: solid transparent;
          border-width: 10px;
          border-bottom-color: #fff;
          content: '';
          position: absolute;
          top: -18px;
          right: 36px;
        }
        .name {
          font-size: 12px;
          margin: 6px 0;
        }
        .phone {
          font-size: 12px;
          color: #666;
          margin: 4px 0;
        }
        .date {
          font-size: 12px;
          color: #999;
          margin: 4px 0;
        }
        .logout {
          cursor: pointer;
          margin: 8px -16px 0;
          padding-top: 12px;
          border-top: 1px solid #f2f2f2;
          font-size: 12px;
          color: #666;
        }
      }
      .menu_search {
        width: 266px;
        height: 34px;
        line-height: 34px;
        margin-left: 60px;
        font-size: 14px;
        background-color: #fff;
        border-radius: 17px;
        overflow: hidden;
        .menu_search_input {
          display: block;
          height: 22px;
          line-height: 22px;
          padding: 0 16px;
          box-sizing: border-box;
          border: none;
          font-size: 14px;
          margin-top: 6px;
          border-right: 1px solid #d8d8d8;
        }
        .search_btn {
          width: 60px;
          text-align: center;
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}
</style>
